import { useNavigate } from "react-router-dom";
import SadCat from "../resource/newfotos/7.jpg";
function NoItems() {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <div className="mx-auto max-w-7xl">
        <div className="relative z-10 pt-14 lg:w-full lg:max-w-2xl">
          <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
            className="absolute inset-y-0 right-8 hidden h-full w-80 translate-x-1/2 transform fill-white lg:block"
          >
            <polygon points="0,0 90,0 50,100 0,100" />
          </svg>

          <div className="relative px-6 py-32 sm:py-40 lg:px-8 lg:py-56 lg:pr-0">
            <div className="mx-auto max-w-2xl lg:mx-16 lg:max-w-xl">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                You have no items in your cart
              </h1>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                Add items to your cart to checkout.
              </p>
              <div className="mt-10 flex items-center gap-x-6">
                <button
                  onClick={() => navigate("/")}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Home
                </button>
                <button
                  onClick={() => navigate("/categories")}
                  className="text-sm font-semibold leading-6 text-gray-900"
                >
                  Shop <span aria-hidden="true">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:w-2/5 lg:h-4/5">
        <img
          alt=""
          src={SadCat}
          className="aspect-[3/2] object-cover lg:aspect-auto lg:h-full lg:w-full"
        />
      </div>
    </div>
  );
}

export default NoItems;
